App.SettingsOrganizationHostController = Em.Controller.extend
  notifier: Em.inject.service()

  organizationBinding: 'model'

  inappSupport: Em.inject.service()

  hostname: Em.computed.oneWay('organization.host')

  hostCheckIsLoading: false

  saveIsDisabled: Ember.computed(
    'hostCheckResult'
    ->
      @get('hostCheckResult')
  )

  hostCheckResult: null

  hostObserver: Ember.observer(
    'hostname'
    'hostIsNotValid'
    ->
      host = @get('hostname')
      hostIsNotValid = @get('hostIsNotValid')

      @set('hostCheckResult', null)

      return if hostIsNotValid

      Ember.run.throttle @, 'validateHost', 300, false
  )

  validateHost: ->
    host = @get('hostname')
    organization = @get('organization')

    @set('hostCheckIsLoading', true)

    organization.checkHost('host': host)
      .then (result) =>
        return if Ember.isEmpty(result)

        status = Ember.get(result, 'status')

        if status is 'not_available'
          # todo i18n
          @set('hostCheckResult', 'данный адрес недоступен')

        if status is 'bad_format'
          # todo i18n
          @set('hostCheckResult', 'неверный формат адреса')

        if status is 'available'
          @set('hostCheckResult', null)
      .finally =>
        @set('hostCheckIsLoading', false)


  actions:
    askSupport: ->
      @get('inappSupport')?.initiateDialogue()
      false

    cancel: ->
      @send('transitionTo', 'settings.organization')
      false

    saveOrganization: ->
      organization = @get('organization')
      hostname     = @get('hostname')

      organization.set('host', hostname)
      organization.save()
      .then =>
        @get('notifier').pushNotification
          type:     'success'
          # todo i18n
          title:    'Готово'
          message:  "Адрес сайта успешно изменен на #{hostname}"

        @send('transitionTo', 'settings.organization')
      .catch =>
        @get('notifier').pushNotification
          type:     'error'
          # todo i18n
          title:    'Ошибка'
          message:  'Произошла ошибка'
